import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { SynchroService } from './SynchroKeycloakService';

/**
 * État global (singleton) de la synchronisation Keycloak ↔ BDD.
 *
 * Source de vérité : l'endpoint GET /synchro/etat, qui se base sur le
 * contenu réel de la BDD — donc fiable même après un redémarrage du
 * backend, contrairement à l'historique des jobs en mémoire.
 */
@Injectable({ providedIn: 'root' })
export class SynchroEtatService {

  private synchro = inject(SynchroService);

  /** null = vérification pas encore faite, true/false = résultat connu. */
  private readonly _synchronise$ = new BehaviorSubject<boolean | null>(null);
  readonly synchronise$ = this._synchronise$.asObservable();

  /** Interroge le backend. À appeler au démarrage de l'app puis après chaque synchro réussie. */
  verifier(): void {
    this.synchro.getEtatSynchro().subscribe({
      next: (etat) => this._synchronise$.next(etat.synchronise),
      // Par prudence, on bloque l'accès si on ne sait pas plutôt que de
      // laisser passer un état inconnu.
      error: () => this._synchronise$.next(false),
    });
  }

  get estSynchronise(): boolean {
    return this._synchronise$.value === true;
  }

  /** true dès que la première vérification a répondu (succès ou échec). */
  get etatConnu(): boolean {
    return this._synchronise$.value !== null;
  }
}